import { render, staticRenderFns } from "./RepeatServiceList.vue?vue&type=template&id=3c2d8f8f&scoped=true&"
import script from "./RepeatServiceList.vue?vue&type=script&lang=js&"
export * from "./RepeatServiceList.vue?vue&type=script&lang=js&"
import style0 from "./RepeatServiceList.vue?vue&type=style&index=0&id=3c2d8f8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d8f8f",
  null
  
)

export default component.exports